import { useSelector } from "react-redux"
import { useQuery } from "@tanstack/react-query"

import { API_ME_URL } from "../constants"
import { IExpensesTurnover, IErrorResponse } from "../interface"
import { RootState } from "../../store/store"
import { checkIsFailure } from "../utils/utils"
import { axios } from "../axios"

export async function getExpensesTurnover(token: string | null) {
  const response = await axios(`${API_ME_URL}/expensesTurnover`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  })

  if (checkIsFailure(response.status)) {
    throw new Error("Ошибка")
  }

  return response.data
}

export const useGetExpensesTurnover = () => {
  const token = useSelector((state: RootState) => state.auth.token)

  return useQuery<IExpensesTurnover, IErrorResponse>({
    queryKey: ["expenses-turnover"],
    queryFn: () => getExpensesTurnover(token),
    refetchOnWindowFocus: false,
    enabled: Boolean(token),
  })
}
